import React, { useCallback, useEffect, useMemo } from 'react'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { rem } from 'polished'
import BannerCarousel from 'components/Common/Banner/BannerCarousel'
import { fetchListBanners } from 'actions/ContentActions'
import { BANNER_LOCATION_HOME } from 'constants/bannerLocations'
import { useAppDispatch } from 'hooks/reduxHooks'
import * as Analytics from 'analytics/analytics'
import { clickHomepageTileEvent } from 'analytics/optimizely/events'
import { EmptyArray, take } from 'lib/array/arrayUtils'

const MarketingCarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

interface Props {
  banners?: Array<App.ListBanner>;
}

function MarketingCarousel(props: Props) {
  const { banners = EmptyArray } = props
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchListBanners(BANNER_LOCATION_HOME))
  // eslint-disable-next-line
  }, [])

  const onBannerClick = useCallback(() => {
    Analytics.track('click-homepage-tile', clickHomepageTileEvent())
  }, [])

  const visibleBanners = useMemo(() => take(banners, 3), [banners])

  return (
    <>
      {banners.length > 0 && (
        <MarketingCarouselContainer>
          <BannerCarousel
            banners={visibleBanners}
            onBannerClick={onBannerClick}
            onClickOpenNewTab
          />
        </MarketingCarouselContainer>
      )}
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    banners: state.content.listBanners.home,
  }
}

export default connect(mapStateToProps)(MarketingCarousel)
